import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Heading from '@atlaskit/heading';
import { Inline, xcss } from '@atlaskit/primitives';
import ToggleReadState from '../../../common/ui/toggle-read-state';
import messages from '../../../common/utils/i18n/messages';
import HeaderDropdownMenu from './dropdown-menu';
import FPNLink from './fpn-link';
export var Header = function Header(_ref) {
  var readStateFilter = _ref.readStateFilter,
    toggleReadStateFilter = _ref.toggleReadStateFilter,
    handleMarkAllNotificationsRead = _ref.handleMarkAllNotificationsRead,
    isMarkAllAsReadVisible = _ref.isMarkAllAsReadVisible,
    spacing = _ref.spacing,
    FullPageButton = _ref.FullPageButton;
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between",
    xcss: spacing === 'comfortable' ? containerStylesComfortable : containerStylesCompact
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    as: "h2",
    id: "notification-list-header-label"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.notifications)), /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(ToggleReadState, {
    readStateFilter: readStateFilter,
    toggleReadStateFilter: toggleReadStateFilter
  }), FullPageButton ? /*#__PURE__*/React.createElement(FullPageButton, null) : /*#__PURE__*/React.createElement(FPNLink, null), /*#__PURE__*/React.createElement(HeaderDropdownMenu, {
    markAllNotificationsRead: function markAllNotificationsRead() {
      return handleMarkAllNotificationsRead('dropdownMenu');
    },
    isMarkAllAsReadVisible: isMarkAllAsReadVisible
  })));
};
var containerStylesComfortable = xcss({
  marginBlockStart: 'space.300',
  marginBlockEnd: 'space.200',
  marginInlineStart: 'space.300',
  marginInlineEnd: 'space.200'
});
var containerStylesCompact = xcss({
  marginBlockStart: 'space.300',
  marginBlockEnd: 'space.200',
  marginInline: 'space.100'
});